import {
    useCallback, useMemo,
} from 'react'
import useEnumValues from 'app/hooks/useEnumValues'
import useLabel from 'app/hooks/useLabel'
import SkyNetSpreadSheet, {
    getEditedItems,
    SkyNetSpreadSheetControlPanel,
} from 'app/shared-components/SkyNetSpreadSheet'
import {
    AsyncMutationOptions,
} from 'app/types/request.types'

import useSyncState from 'app/hooks/useSyncState'
import {
    RegionalServiceAvailabilityItem,
} from '../RegionalServiceAvailability.types'
import getConfig from './RegionalServiceAvailabilitySpreadsheet.config'

export default function RegionalServiceAvailabilitySpreadsheet({
    data,
    onSave,
    onCancel,
}: Readonly<{
    data: RegionalServiceAvailabilityItem[];
    onSave: (v: RegionalServiceAvailabilityItem[], o?: AsyncMutationOptions) => void;
    onCancel?: (...args: any[]) => void;
}>) {
    const getAllowedValues = useEnumValues()
    const getLabel = useLabel()
    const {
        value,
        setValue,
    } = useSyncState<RegionalServiceAvailabilityItem[]>(data)

    const editedItems = useMemo(() => {
        return getEditedItems({
            allItems: value,
            initData: data,
        })
    }, [
        data,
        value,
    ])

    const handleSave = useCallback(
        async (options?: { onSuccess?: (...a: any) => void }) => {
            return onSave(editedItems, options)
        },
        [
            editedItems,
            onSave,
        ],
    )

    const config = useMemo(() => {
        return getConfig({
            getLabel,
            getAllowedValues,
        })
    }, [
        getLabel,
        getAllowedValues,
    ])

    const edited = Boolean(editedItems.length)

    return (
        <SkyNetSpreadSheetControlPanel
            onSave={handleSave}
            onCancel={onCancel}
            edited={edited}
            isFullScreen
        >
            <SkyNetSpreadSheet
                config={config}
                value={value}
                onChange={setValue}
            />
        </SkyNetSpreadSheetControlPanel>
    )
}
